import FormBaseComponent, { type OptionalFormBaseComponentState } from "./FormBaseComponent";
export { FormBaseComponent };
export type { OptionalFormBaseComponentState };
export default FormBaseComponent;
